import { SignType, WidgetOption, WidgetType } from '@/types'
import seal from '../seal'
import { transSpecToPx } from '../seal/utils'

/** 签名 */
export default {
  ...seal,
  key: SignType.SIGNATURE,
  name: '签名',
  type: WidgetType.SIGNATURE,
  icon: 'fa-icon-widget-signature',
  width: transSpecToPx(30),
  height: transSpecToPx(16)
} as WidgetOption
